<template>
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading client  ...
        </div>
        <div class="notification is-danger" v-if="loading === false && client.id == 0">
            Client details cannot be found
        </div>

        <div v-if="loading == false && client.id > 0">
            <div v-if="SYSTEM_TYPE=='HOMECARE'">
                <h4 class="title is-size-4">Activity Diary for {{ client.name }}</h4>

                <div class="columns">
                    <div class="column"><span @click="nextBooking" style="cursor:pointer" v-if="selectedIndex < client.bookings.length - 1">&lt;&lt; Previous</span></div>
                    <div class="column has-text-centered">
                        <select class="select"  v-model="selectedIndex">
                            <option v-for="(row, index) in client.bookings" :key="row.id" :value="index">{{ row.start_date_formatted }} - {{ row.forename }} {{ row.surname }} - {{  row.id }}</option>
                        </select>
                    </div>
                    <div class="column has-text-right"><span style="cursor:pointer" @click="previousBooking" v-if="selectedIndex > 0">Next &gt;&gt;</span></div>
                </div>

                <div v-if="client.bookings.length == 0" class="notification is-danger">
                    No dairy entries have been added for this client in the selected time period
                </div>
                <div v-if="client.bookings.length > 0">
                    <div v-if="selectedBooking">
                         <p style="text-decoration:underline;display:none" >{{ selectedBooking.start_date_formatted }} - {{ selectedBooking.forename }} {{ selectedBooking.surname }} - {{ selectedBooking.id }}</p><br />
                        
                         <div class="notification is-warning mb-4" v-if="selectedBooking.activities==0">
                            There have been no activities saved for this booking.
                         </div>
                         <div v-for="activity in selectedBooking.activities" :key="activity.id">
                            
                            <div class="box">
                                 <article class="media">
                                    
                                    <div class="media-content">
                                    <div class="content">
                                        <p>
                                        <span class="tag is-danger" v-if="activity.alert == 1">Alert</span><br />
                                        <strong>Action : {{  activity.activity_name }} </strong><br />
                                        Time : {{  activity.time }}<br />
                                        Notes : <em>{{ activity.notes}}</em><br />
                                        
                                        
                                        </p>
                                    </div>
                                    
                                    </div>
                                </article>
                                </div>
                            
                         </div>
                         <p class="has-text-centered mt-4">
                            <button class="button is-link">Print Daily Record for {{ selectedBooking.start_date_formatted}}</button>
                         </p>
                    </div>
                </div>
                <hr />
            </div>

            

           
        </div>

        
    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import BookingService from '@/services/BookingService.js';
import MemberMixin from '@/mixins/MemberMixin.js';
//import { client } from '@auth0/auth0-vue/dist/typings/plugin';

export default {
    
      name: 'ClientGroups',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   client: [],
                   loading: true,
                   working: false,
                   accessToken: '',
                   showModal: false,
                   client_groups: [],
                   client_group_billing_profiles: [],
                   user: [{billing: 0}],
                   name : '',
                    code: '',
                    description: '',
                    telephone: '',
                    cost_centre: '',
                    client_group_id: 0,
                    SYSTEM_TYPE: process.env.VUE_APP_SYSTEM_TYPE,
                    selectedIndex: 0
            }
        },
        methods: {
            nextBooking() {
                if (this.selectedIndex < this.client.bookings.length - 1) {
                    this.selectedIndex++;
                }
                },
                previousBooking() {
                if (this.selectedIndex > 0) {
                    this.selectedIndex--;
                }
                },
            setSelectedBookingFromQuery() {
                if (!this.client.bookings || this.client.bookings.length === 0) {
                    this.selectedIndex = 0;
                    return;
                }

                const bookingId = parseInt(this.$route.query.booking_id, 10);

                if (Number.isNaN(bookingId)) {
                    this.selectedIndex = 0;
                    return;
                }

                const bookingIndex = this.client.bookings.findIndex((booking) => booking.id === bookingId);
                this.selectedIndex = bookingIndex >= 0 ? bookingIndex : 0;
            },
            async getClient() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "clients/" + this.$route.params.id + "?with_bookings=1&with_activities=1")
                .then(
                    (client => {
                        this.$set(this, "client", client);
                        this.setSelectedBookingFromQuery();

                        this.getClientGroupBillingProfiles();

                        this.loading=false
                    }).bind(this)
                );

                this.name = ''
                this.code= ''
                this.description= ''
                this.telephone= ''
                this.cost_centre= ''

            },
            showNewWardModal() {
                this.showModal = true
            },
            async saveWard() {
                this.working = true
                var formdata = { 
                    client_id: this.$route.params.id,
                    name : this.name,
                    code: this.code,
                    description: this.description,
                    telephone: this.telephone,
                    cost_centre: this.cost_centre,
                    
                    
                }; 

                BookingService.saveWard(this.accessToken, formdata)
                .then((response) => {
                    this.closeModal();
                    console.log(response)
                    this.working = false
                    this.getClient();
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },
            async updateClient() {
                this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        name: this.client.name,
                        code: this.client.code,
                        cost_centre: this.client.cost_centre,
                        default_break: this.client.default_break,
                        client_group_id: this.client.client_group_id,
                        client_group_billing_profile_id: this.client.client_group_billing_profile_id,
                        address1: this.client.address1,
                        address2: this.client.address2,
                        address3: this.client.address3,
                        city: this.client.city,
                        postcode: this.client.postcode,
                        break_notes: this.client.break_notes
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.getClient();
                            alert("Client Updated")
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
            },
            async removeClient() {
                if(confirm('Are you sure you want to remove this client from the database ?'))
                {
                    this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        active:0
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.$router.push("/billing/client-groups/" + this.client.client_group_id);
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
                }
                else {
                    return false
                }
            },
            async hideClient() {
                if(confirm('Are you sure you want to hide this client in the database ? It will remain visible in the  admin areas but no bookings can be added for it.'))
                {
                    this.working = true;
                
                    var formdata = { 
                        _method: 'patch',
                        hide_client:1
                    }; 

                    BookingService.updateClient(this.accessToken, this.client.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            
                            this.$router.push("/billing/client-groups/" + this.client.client_group_id);
                        }
                    ).catch((error) => { 
                        console.log(error)
                        if (error.response.status == 409) {
                            alert(error.response.data.error)
                        } 
                        else{
                            alert(error.message)
                        } 
                        this.working=false;
                        
                    });
                }
                else {
                    return false
                }
            },
            async getClientGroupBillingProfiles() {
                this.client_group_billing_profiles = []

                UtilityService.getSimpleApiData(this.accessToken, "client_group_billing_profiles?client_group_id=" + this.client.client_group_id)
                .then(
                    (client_group_billing_profiles => {
                        this.$set(this, "client_group_billing_profiles", client_group_billing_profiles);
                    }).bind(this)
                );
            },
            async getClientGroups() {
                
                UtilityService.getSimpleApiData(this.accessToken, "client_groups")
                .then(
                    (client_groups => {
                        this.$set(this, "client_groups", client_groups);
                       
                    }).bind(this)
                );
            },
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getClient();
                //this.getClientGroups();
                this.getUserSelf()
                
            });
        
        },
        watch: {
            client_group_id: function() {
                //this.getClientGroupBillingProfiles();
            },
            '$route.query.booking_id': function() {
                this.setSelectedBookingFromQuery();
            },
           
        },
        computed: {
            selectedBooking() {
            return this.client.bookings[this.selectedIndex] || null
            }
        }
    }
</script>